<button
    class="mobile-icon"
    nz-button
    nzType="link"
    type="button"
    *ngIf="!isInvalid"
    (click)="isOpenInMobile = !isOpenInMobile"
    nzSize="small"
>
    {{ (!isOpenInMobile ? 'global-filter.show-filters' : 'global-filter.hide-filters') | translate }}
    <adspt-icon [name]="isOpenInMobile ? 'caret-up' : 'caret-down'" />
</button>
<div
    class="wrapper"
    *ngIf="!isInvalid"
    [class.disabled]="globalFilterNotFoundError$ | async"
    nz-tooltip
    [nzTooltipTitle]="(globalFilterNotFoundError$ | async) ? ('global-filter.click-reset-filter' | translate) : ''"
>
    <div class="left" [ngClass]="{ open: isOpenInMobile }">
        <div class="refiner filter" *ngIf="accountSelector.enable" [ngClass]="{ disabled: accountSelector.disable }">
            <adspt-account-selector
                *ngIf="accountSelector.render"
                [enableAdvancedMode]="accountSelector.enableAdvancedMode"
                [enableAdvancedFilterSelection]="accountSelector.enableAdvancedFilterSelection"
                [disableReset]="accountSelector.disableReset"
                [disableCloseIcon]="!options.xAccount"
                [forcedFilter]="options.forcedFilters?.[REFINER_ACCOUNT]"
                (selectionChange)="accountSelector.onSelectionChange($event)"
                (reset)="accountSelector.onReset($event)"
            >
            </adspt-account-selector>
            <div class="loader ant-btn" [@fadeAnimation] *ngIf="!accountSelector.render">
                <nz-spin nzSimple nzSize="small"></nz-spin>
            </div>
        </div>
        <div
            class="refiner filter"
            *ngIf="pgSelector.enable"
            [ngClass]="{ disabled: pgSelector.notSelectable || pgSelector.disable }"
        >
            <adspt-pg-selector
                *ngIf="pgSelector.render"
                [hideInactive]="options.hideInactiveGroup"
                [hasDestinationSelector]="!!options?.destinationSelectors?.PG"
                [enableAdvancedMode]="pgSelector.enableAdvancedMode"
                [enableAdvancedFilterSelection]="pgSelector.enableAdvancedFilterSelection"
                [disableReset]="pgSelector.disableReset"
                [forcedFilter]="options.forcedFilters?.[REFINER_PG]"
                (selectionChange)="pgSelector.onSelectionChange($event)"
                (reset)="pgSelector.onReset($event)"
            >
            </adspt-pg-selector>
            <div class="loader ant-btn" [@fadeAnimation] *ngIf="!pgSelector.render">
                <nz-spin nzSimple nzSize="small"></nz-spin>
            </div>
        </div>

        <div class="refiner filter" *ngIf="campaignSelector.enable" [ngClass]="{ disabled: campaignSelector.disable }">
            <adspt-campaign-selector
                *ngIf="campaignSelector.render"
                [hasDestinationSelector]="!!options?.destinationSelectors?.CAMPAIGN"
                [enableAdvancedMode]="campaignSelector.enableAdvancedMode"
                [enableAdvancedFilterSelection]="campaignSelector.enableAdvancedFilterSelection"
                [disableReset]="campaignSelector.disableReset"
                [forcedFilter]="options.forcedFilters?.[REFINER_CAMPAIGN]"
                (selectionChange)="campaignSelector.onSelectionChange($event)"
                (reset)="campaignSelector.onReset($event)"
            >
            </adspt-campaign-selector>
            <div class="loader ant-btn" [@fadeAnimation] *ngIf="!campaignSelector.render">
                <nz-spin nzSimple nzSize="small"></nz-spin>
            </div>
        </div>

        <div
            class="refiner filter"
            *ngIf="adGroupsSelector.enable"
            nz-tooltip
            [nzTooltipTitle]="'global-filter.adgroup-selector.not-selectable' | translate"
            nzTooltipPlacement="top"
            [nzTooltipMouseEnterDelay]="adGroupsSelector.notSelectable ? 0.5 : 99999"
            [ngClass]="{ disabled: disableAdgroups || adGroupsSelector.disable }"
        >
            <adspt-ad-group-selector
                *ngIf="adGroupsSelector.render"
                [hasDestinationSelector]="!!options?.destinationSelectors?.ADGROUP"
                [enableAdvancedMode]="adGroupsSelector.enableAdvancedMode"
                [enableAdvancedFilterSelection]="adGroupsSelector.enableAdvancedFilterSelection"
                [disableReset]="adGroupsSelector.disableReset"
                [forcedFilter]="options.forcedFilters?.[REFINER_ADGROUP]"
                (selectionChange)="adGroupsSelector.onSelectionChange($event)"
                (reset)="adGroupsSelector.onReset($event)"
            >
            </adspt-ad-group-selector>
            <div class="loader ant-btn" [@fadeAnimation] *ngIf="!adGroupsSelector.render">
                <nz-spin nzSimple nzSize="small"></nz-spin>
            </div>
        </div>

        <div
            class="refiner filter"
            *ngIf="criteriaSelector.enable"
            nz-tooltip
            [nzTooltipTitle]="'global-filter.criteria-selector.not-selectable' | translate"
            nzTooltipPlacement="top"
            [nzTooltipMouseEnterDelay]="criteriaSelector.notSelectable ? 0.5 : 99999"
            [ngClass]="{
                disabled: disableCriteria || criteriaSelector.notSelectable || criteriaSelector.disable,
            }"
        >
            <adspt-criteria-selector
                *ngIf="criteriaSelector.render"
                [enableAdvancedMode]="criteriaSelector.enableAdvancedMode"
                [enableAdvancedFilterSelection]="criteriaSelector.enableAdvancedFilterSelection"
                [disableReset]="criteriaSelector.disableReset"
                [forcedFilter]="options.forcedFilters?.[REFINER_CRITERIA]"
                (selectionChange)="criteriaSelector.onSelectionChange($event)"
                (reset)="criteriaSelector.onReset($event)"
            >
            </adspt-criteria-selector>
            <div class="loader ant-btn" [@fadeAnimation] *ngIf="!criteriaSelector.render">
                <nz-spin nzSimple nzSize="small"></nz-spin>
            </div>
        </div>
    </div>
    <div class="right">
        <button
            nz-button
            nz-tooltip
            nzType="default"
            class="delay"
            nzTooltipPlacement="top"
            (click)="delayChange(!delay())"
            [class.a-color-light-blue]="delay()"
            [class.open]="isOpenInMobile"
            *ngIf="options.hasDelaySelector"
            adsptHeap="conversion-delay-switch"
            [heapData]="{ 'disable/enable': delay() }"
            [nzTooltipTitle]="(delay() ? 'monitor.conversion-delay-on' : 'monitor.conversion-delay-off') | translate"
        >
            <adspt-icon name="timer" size="18px" />
        </button>
        <div class="refiner search" *ngIf="enableSearchBox" [ngClass]="{ open: isOpenInMobile }">
            <nz-input-group [nzPrefix]="prefixIconSearch" [nzSuffix]="suffixTemplate">
                <input
                    type="text"
                    nz-input
                    [placeholder]="options.searchBoxPlaceholder || ('global-filter.search-placeholder' | translate)"
                    adsptHeap="global-search-bar"
                    [formControl]="queryInput"
                />
            </nz-input-group>
            <ng-template #prefixIconSearch>
                <adspt-icon name="zoom" class="search" />
            </ng-template>
            <ng-template #suffixTemplate>
                <adspt-icon *ngIf="!!queryInput.value" (click)="onSearchReset()" name="close-circle" />
            </ng-template>
        </div>
        <div class="refiner date" *ngIf="dateSelector.enable" [ngClass]="{ open: isOpenInMobile }">
            <adspt-date-range-selector
                *ngIf="dateSelector.render"
                [dates]="dateSelector.value"
                [compareDates]="dateSelector.compareValue"
                [hasCompareRange]="options.hasCompareSelector"
                (close)="dateSelector.onChange($event)"
            ></adspt-date-range-selector>
            <div class="loader ant-btn" [@fadeAnimation] *ngIf="!dateSelector.render">
                <nz-spin nzSimple nzSize="small"></nz-spin>
            </div>
        </div>
        @if (isOpenInMobile) {
            <div class="refiner-wrapper open">
                <ng-content select="[hideInMobile]"></ng-content>
            </div>
        }
        <ng-content select="[showInMobile]"></ng-content>
        <ng-content select="[rightSection]"></ng-content>
    </div>
</div>

<ng-content select="[newLineSection]"></ng-content>
